/**
 * AAA IDP consent form reducer
 * 
 */
import { DELETE, CONSENT_FORM, CONSENT_FORM_REQUIRED_ATTRIBUTE, CONSENT_FORM_ERROR } from '../../actions/types';
export const initialState = {
  error: false,
  errorMessage: '',
  fileName: '',
  required: false,
  valid: null,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case CONSENT_FORM:
      {
        const {
          value,
          fileName
        } = action;
        const valid = value ? true : false;
        return {
          ...state,
          error: false,
          errorMessage: '',
          fileName,
          value,
          valid
        };
      }
    case CONSENT_FORM_REQUIRED_ATTRIBUTE:
      {
        const {
          required
        } = action;
        return {
          ...state,
          required: required
        };
      }
    case CONSENT_FORM_ERROR:
      {
        const {
          error,
          message
        } = action;
        return {
          ...state,
          error,
          errorMessage: message,
          valid: !error
        };
      }
    default:
      return state;
  }
}